import { css, FlattenSimpleInterpolation } from 'styled-components/macro'

/**
 * Outline icons -- drawn with strokes, and marked class="outline-icon" in their
 * SVG (the questionnaire icons in Icons/Basic) -- take a container's icon colour
 * as their stroke. Containers that colour icons with `svg path { fill }` would
 * otherwise fill their outlines into solid shapes.
 *
 * More specific than `svg path`, so it wins over those rules; pass `important`
 * where the container's own rule is !important (the nav rail).
 */
export const outlineIconColor = (
  color: string,
  important = false,
): FlattenSimpleInterpolation => {
  const flag = important ? ' !important' : ''
  return css`
    svg.outline-icon [stroke] {
      fill: none ${flag};
      stroke: ${color}${flag};
    }
  `
}
